var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSliderVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 9c0-1.66-1.34-3-3-3H5C3.34 6 2 7.34 2 9v6c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V9zM18.07 19.5a.5.5 0 0 1 .49.6c-.27 1.48-1.14 1.9-3.23 1.9H8.67c-2.1 0-2.96-.42-3.23-1.9a.5.5 0 0 1 .49-.6h12.14zM15.33 2c2.1 0 2.96.42 3.23 1.9.06.31-.18.6-.49.6H5.93a.5.5 0 0 1-.49-.6C5.71 2.42 6.57 2 8.67 2h6.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSliderVertical);
export default __webpack_public_path__ + "static/media/vuesax-bold-slider-vertical.9ed625cf9c2f6c93f6d2744eaf5bc050.svg";
export { ForwardRef as ReactComponent };